import { defineMessages } from 'react-intl';

import { buttonSchema } from '../Button/schema';

import { ButtonSchemaEnhancerForGroup } from './ButtonSchemaEnhancerForGroup';

const messages = defineMessages({
  groupButton: { id: 'Group Button', defaultMessage: 'Group Button' },
  layout: { id: 'Layout', defaultMessage: 'Layout' },
  buttons: { id: 'Buttons', defaultMessage: 'Buttons' },
  align: { id: 'Align', defaultMessage: 'Align' },
});

export const GroupButtonSchema = (props) => {
  return {
    fieldsets: [
      {
        id: 'default',
        title: props.intl.formatMessage(messages.groupButton),
        fields: ['buttons'],
      },
      {
        id: 'layout',
        title: props.intl.formatMessage(messages.layout),
        fields: ['align'],
      },
    ],
    properties: {
      buttons: {
        widget: 'object_list',
        title: props.intl.formatMessage(messages.buttons),
        schema: buttonSchema(props),
        schemaExtender: ButtonSchemaEnhancerForGroup,
      },
      align: {
        title: props.intl.formatMessage(messages.align),
        widget: 'align',
        default: 'center',
        actions: ['left', 'center', 'right'],
      },
    },
    required: [],
  };
};
